
import service from "../service";

// Obtiene el registro más reciente
export const getLatestServerStats = () => (
  service('get', `v3/admin/server/latest`)
);

// Obtiene el histórico por rango de fechas
export const getServerStatsHistory = (data) => (
  service('post', `v3/admin/server/history`, { data })
);

